import { createFileRoute, Link } from '@tanstack/react-router';

import { Button, PageHeader, PageLayout } from '@keboola/design';
import { ArrowLeft } from '@keboola/design/icons';

import { useCurrentVendor } from '../../../../auth/context';
import { VersionHistory } from '../../../../features/apps/components/VersionHistory';
import { getAppTitle } from '../../../../features/apps/helpers';
import { useVendorApp } from '../../../../features/vendors/queries';

export const Route = createFileRoute('/~/components/$appId/versions')({
  component: VendorComponentVersionsPage,
  head: () => ({ meta: [{ title: 'Component versions | Keboola Developer Portal' }] }),
});

function VendorComponentVersionsPage() {
  const { appId } = Route.useParams();
  const vendorId = useCurrentVendor();
  const { data: app } = useVendorApp(vendorId, appId);

  return (
    <PageLayout>
      <PageLayout.Header>
        <PageHeader.Detail
          title={app === undefined ? appId : getAppTitle(app)}
          description="Every stored version. Revert to one to restore all of its settings."
          breadcrumbs={
            <Button asChild variant="inline">
              <Link to="/~/components/$appId" params={{ appId }}>
                <ArrowLeft />
                Back to the component
              </Link>
            </Button>
          }
        />
      </PageLayout.Header>

      <VersionHistory vendorId={vendorId} appId={appId} />
    </PageLayout>
  );
}
